import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  brand_name: "LocalDoctor",
  tagline: "Doctor chahiye… milega.",
  hero_subtitle:
    "Find trusted doctors near you. Search by location, specialty or doctor name — then book a slot and skip the queue with an OTP you show at the clinic.",
  meta_description:
    "LocalDoctor.in — Doctor chahiye… milega. Find trusted doctors near you across India.",
  logo_url: "",
  footer_tagline:
    "Doctor chahiye… milega. Discover trusted doctors and clinics across India, starting with Pune.",
  about_mission:
    "LocalDoctor.in helps people in India quickly find trusted local doctors and clinics — and skip the queue once they're there. Our mission is simple: make everyday medical visits less stressful.",
  founder_name: "Shwet Tiwari",
  founder_title: "Founder & Builder",
  founder_bio:
    "Finding a trustworthy doctor and getting seen on time shouldn't be the hardest part of feeling unwell. I started LocalDoctor.in so every family in India can discover verified local clinics in seconds — and walk in with an OTP instead of waiting in line.",
  founder_photo_url: "",
  founder_email: "shwet@localdoctor.in",
  founder_linkedin_url: "https://www.linkedin.com/",
  support_email: "support@localdoctor.in",
  doctors_email: "doctors@localdoctor.in",
  whatsapp_number: "",
};

const SettingsCtx = createContext({ settings: DEFAULTS, loading: true, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-settings");
      setSettings({ ...DEFAULTS, ...(data.settings || {}) });
    } catch {
      // fall back to defaults silently
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <SettingsCtx.Provider value={{ settings, loading, refresh }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  return useContext(SettingsCtx);
}
